import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';
import InputGroup from 'react-bootstrap/InputGroup';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Select from 'react-select';

import { fetchRequest } from '../../fetchRequest';
import { TOAST_WARN } from './shopUtils';

export function UserSearchModal({ show, classes, currentUser, onClose, onUserSelected, onFocusedChange }) {

    const [searchUserType, setSearchUserType] = useState('student');
    const [searchStudents, setSearchStudents] = useState([]);
    const [searchSelectedStudent, setSearchSelectedStudent] = useState(null);
    const [searchUsers, setSearchUsers] = useState([]);
    const [searchSelectedUser, setSearchSelectedUser] = useState(null);
    const [studentSearchQuery, setStudentSearchQuery] = useState('');
    const [userSearchQuery, setUserSearchQuery] = useState('');
    const [selectedClass, setSelectedClass] = useState(null);
    const [selectedClassStudent, setSelectedClassStudent] = useState(null);
    const [classStudents, setClassStudents] = useState([]);

    const loadStudents = (code = null, classId = null) => {
        setClassStudents([]);
        setStudentSearchQuery('');
        fetchRequest("app/student", 'POST', {
            school: currentUser?.school,
            studentCode: code,
            class: classId
        })
            .then(res => {
                if (res?.success) {
                    let selectedClassObj = null;
                    let selectedStudentObj = null;
                    if (classes && classes.length > 0) {
                        for (let c = 0; c < classes.length; c++) {
                            if (classes[c]?.value === res?.selectedClass) {
                                selectedClassObj = classes[c];
                                break;
                            }
                        }
                    }
                    if (res?.students && res?.students.length > 0) {
                        for (let st = 0; st < res?.students.length; st++) {
                            if (res?.students[st]?.value === res?.selectedStudent) {
                                selectedStudentObj = res?.students[st];
                                break;
                            }
                        }
                    }
                    setSelectedClass(selectedClassObj);
                    setSelectedClassStudent(selectedStudentObj);
                    setClassStudents(res?.students);
                } else {
                    toast.warning(res?.message || 'Мэдээлэл олдсонгүй', TOAST_WARN);
                }
            }).catch(() => {
                toast.warning('Хүсэлт илгээхэд алдаа гарлаа', TOAST_WARN);
            });
    };

    const searchSubmit = (userType = 'STUDENT', query = null) => {
        fetchRequest("app/kiosk/sale/search-user", 'POST', {
            school: currentUser?.school,
            userType,
            query
        })
            .then(res => {
                if (!res?.success) {
                    toast.warning(res?.message || (userType === 'STUDENT' ? 'Сурагч хайхад алдаа гарлаа' : 'Ажилтан хайхад алдаа гарлаа'), TOAST_WARN);
                } else if (res?.users?.length === 0) {
                    toast.warning(query + ' кодтой хэрэглэгч олдсонгүй', TOAST_WARN);
                }
                if (userType === 'STUDENT') {
                    setStudentSearchQuery('');
                    setSearchStudents(res?.users);
                } else {
                    setUserSearchQuery('');
                    setSearchUsers(res?.users);
                }
            }).catch(() => {});
    };

    const onSelectUser = () => {
        if (searchUserType === 'student') {
            if (searchSelectedStudent) {
                onUserSelected({
                    id: searchSelectedStudent?.value,
                    avatar: searchSelectedStudent?.avatar,
                    className: searchSelectedStudent?.class,
                    code: searchSelectedStudent?.code,
                    firstName: searchSelectedStudent?.firstname,
                    lastName: searchSelectedStudent?.lastname,
                    userType: 'STUDENT'
                });
                handleClose();
            } else if (selectedClassStudent) {
                onUserSelected({
                    id: selectedClassStudent?.value,
                    avatar: selectedClassStudent?.avatar,
                    className: selectedClassStudent?.class,
                    code: selectedClassStudent?.code,
                    firstName: selectedClassStudent?.firstname,
                    lastName: selectedClassStudent?.lastname,
                    userType: 'STUDENT'
                });
                handleClose();
            } else {
                toast.warning("Сурагч сонгоно уу", TOAST_WARN);
            }
        } else if (searchUserType === 'user') {
            if (searchSelectedUser) {
                onUserSelected({ ...searchSelectedUser, userType: 'USER' });
                handleClose();
            } else {
                toast.warning("Багш, ажилтан сонгоно уу", TOAST_WARN);
            }
        }
    };

    const handleClose = () => {
        setSearchStudents([]);
        setSearchSelectedStudent(null);
        setSelectedClass(null);
        setSelectedClassStudent(null);
        setStudentSearchQuery('');
        onClose();
    };

    return (
        <Modal show={show} size='xl' backdrop="static" onHide={handleClose}>
            <Modal.Header style={{ padding: '20px 40px', border: 'none' }} closeButton>
                <Modal.Title className='accent'>Хайлт</Modal.Title>
            </Modal.Header>
            <Modal.Body className={'p-0'} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Tab.Container id="left-tabs-example" defaultActiveKey="student" onSelect={setSearchUserType}>
                    <Nav variant="pills" className="text-center" style={{ display: 'inline-flex', margin: 'auto' }}>
                        <Nav.Item><Nav.Link eventKey="student">Сурагч</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link eventKey="user">Багш, ажилтан</Nav.Link></Nav.Item>
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey="student" style={{ padding: 30 }}>
                            <Row>
                                <Col md={1} lg={2} />
                                <Col md={10} lg={8}>
                                    <Row>
                                        <Col>
                                            <Select
                                                onChange={(data) => {
                                                    loadStudents(null, data?.value);
                                                    setSelectedClass(data);
                                                }}
                                                isSearchable={false}
                                                placeholder='- Анги сонгох -'
                                                value={selectedClass}
                                                options={classes}
                                            />
                                        </Col>
                                        <Col>
                                            <Select
                                                onChange={(e) => setSelectedClassStudent(e)}
                                                isSearchable={false}
                                                placeholder='- Сурагч сонгох -'
                                                value={selectedClassStudent}
                                                options={classStudents}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className='mt-10 mb-10' style={{ zIndex: '0 !important' }}>
                                        <Col>
                                            <InputGroup style={{ zIndex: '0 !important' }}>
                                                <Form.Control
                                                    aria-label="Сурагчийн код"
                                                    placeholder='Сурагчийн код, нэр хайх'
                                                    size='lg'
                                                    style={{ borderRight: 'none' }}
                                                    value={studentSearchQuery}
                                                    onChange={(e) => setStudentSearchQuery(e.target.value)}
                                                    onFocus={() => onFocusedChange(true)}
                                                    onKeyUp={(e) => {
                                                        if (e.key === 'Enter') {
                                                            setSelectedClass(null);
                                                            setSelectedClassStudent(null);
                                                            searchSubmit('STUDENT', studentSearchQuery);
                                                        }
                                                    }}
                                                    onBlur={() => onFocusedChange(false)}
                                                />
                                                <Button type={'button'} variant="outline-secondary" className='btn-search'
                                                    onClick={() => {
                                                        if (studentSearchQuery && studentSearchQuery.trim().length > 0) {
                                                            setSelectedClass(null);
                                                            setSelectedClassStudent(null);
                                                            searchSubmit('STUDENT', studentSearchQuery);
                                                        }
                                                    }}>
                                                    <Image alt='search' className="icon-dashboard" src={`/assets/images/ic_search.png`} />
                                                </Button>
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    {searchStudents && searchStudents.length > 0 && searchStudents.map(studentObj => (
                                        <Row key={'search_student_' + studentObj?.id}
                                            className={searchSelectedStudent === studentObj?.id ? 'search-student-row selected' : 'search-student-row'}
                                            onClick={() => {
                                                onUserSelected({ ...studentObj, userType: 'STUDENT' });
                                                setSearchSelectedStudent(studentObj?.id);
                                            }}>
                                            <Col className='col-auto'>
                                                <img alt='avatar' style={{ width: 100 }}
                                                    src={studentObj?.avatar || 'https://erp.eschool.mn/img/system/default-profile.png'} />
                                            </Col>
                                            <Col style={{ textAlign: 'left' }}>
                                                <p className='m-0 mt-10'>{studentObj?.className}</p>
                                                <p className='m-0'>{studentObj?.code}</p>
                                                <p className='m-0'>{studentObj?.lastName}</p>
                                                <b className='m-0'>{studentObj?.firstName}</b>
                                            </Col>
                                        </Row>
                                    ))}
                                </Col>
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="user" style={{ padding: 30 }}>
                            <Row>
                                <Col md={1} lg={2} />
                                <Col md={10} lg={8}>
                                    <Row className='mb-10'>
                                        <Col>
                                            <InputGroup style={{ zIndex: '0 !important' }}>
                                                <Form.Control
                                                    aria-label="Багш ажилтны код, нэр хайх"
                                                    placeholder='Багш ажилтны код, нэр хайх'
                                                    size='lg'
                                                    style={{ borderRight: 'none' }}
                                                    value={userSearchQuery}
                                                    onChange={(e) => setUserSearchQuery(e.target.value)}
                                                    onFocus={() => onFocusedChange(true)}
                                                    onKeyUp={(e) => {
                                                        if (e.key === 'Enter') searchSubmit('USER', userSearchQuery);
                                                    }}
                                                    onBlur={() => onFocusedChange(false)}
                                                />
                                                <Button type={'button'} variant="outline-secondary" className='btn-search'
                                                    onClick={() => {
                                                        if (userSearchQuery && userSearchQuery.trim().length > 0) {
                                                            searchSubmit('USER', userSearchQuery);
                                                        }
                                                    }}>
                                                    <Image alt='search' className="icon-dashboard" src={`/assets/images/ic_search.png`} />
                                                </Button>
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                    {searchUsers && searchUsers.length > 0 && searchUsers.map(userObj => (
                                        <Row key={'search_user_' + userObj?.id}
                                            className={searchSelectedUser === userObj?.id ? 'search-student-row selected' : 'search-student-row'}
                                            onClick={() => {
                                                onUserSelected({ ...userObj, userType: 'USER' });
                                                setSearchSelectedUser(userObj?.id);
                                            }}>
                                            <Col className='col-auto'>
                                                <img alt='avatar' style={{ width: 100 }}
                                                    src={userObj?.avatar || 'https://erp.eschool.mn/img/system/default-profile.png'} />
                                            </Col>
                                            <Col style={{ textAlign: 'left' }}>
                                                <p className='m-0 mt-10'>{userObj?.title}</p>
                                                <p className='m-0'>{userObj?.code}</p>
                                                <p className='m-0'>{userObj?.lastName}</p>
                                                <b className='m-0'>{userObj?.firstName}</b>
                                            </Col>
                                        </Row>
                                    ))}
                                </Col>
                            </Row>
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>

                <Row className='mb-10 mt-20'>
                    <Col className='text-center'>
                        <Button variant="link" style={{ marginRight: 5 }} onClick={handleClose}>Цуцлах</Button>
                        <Button className="btn-outline" onClick={onSelectUser}>Сонгох</Button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}
